var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner',{attrs:{"bannerinfo":_vm.alldata.independence.banner},on:{"consult":function($event){return _vm.gotopage('/consult')}}}),(_vm.alldata.nav.current.text==='English')?_c('Enindependence'):_c('Zhindependence')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }